import React, { Component } from 'react';
import { Form, Input, Icon, Button, Layout, Row, Col } from 'antd';
import displayServerErrors from '../../../utilities/form/display_server_errors';
import { graphql, compose } from 'react-apollo';
import PropTypes from 'prop-types';
import { UserPhoto } from "../../common/userPhoto/userPhoto";
import { getCurrentUser } from '../../authorization/queries/getCurrentUser';
import { updateUser } from './mutations/updateUser';
import { FIELDS, ROLES } from "./constants";

const FormItem = Form.Item;

class ProfileForm extends Component {
  static propTypes = {
    data: PropTypes.shape({
      current_user: PropTypes.object,
    }).isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    mutate: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  get mutationParams() {
    return {
      variables: {
        input: {
          ...this.props.form.getFieldsValue()
        }
      }
    }
  }

  async submitData() {
    try {
      this.setState({...this.state, loading: true});
      const {data} = await this.props.mutate(this.mutationParams);
      this.props.onSubmit(data.current_user)
    } catch(response) {
      displayServerErrors(this.props.form, response)
    } finally {
      this.setState({ loading: false });
    }
  }

  onSubmit = (event) => {
    event.preventDefault();

    this.props.form.validateFields((error) => {
      if (!error) {
        this.submitData();
      }
    });
  };

  onPhotoLoad = (photoDataUri) => {
    this.props.form.setFieldsValue({ photo_data_uri: photoDataUri });
  };

  onPhotoRemove = () => {
    const {setFieldsValue} = this.props.form;
    setFieldsValue({ remove_photo: true, photo_data_uri: '' });
  };

  renderPhotoDataUriField() {
    const {getFieldDecorator} = this.props.form;
    return (
      <div className="profile-page__photo-block">
        <FormItem className="profile-form__item--nomargin">
          {getFieldDecorator('photo_data_uri')(
            <UserPhoto photoURL={this.props.data.current_user.photo.small} onPhotoLoad={this.onPhotoLoad}
                       onPhotoRemove={this.onPhotoRemove} />
          )}
        </FormItem>
        <FormItem className="profile-form__item--hidden">
          {getFieldDecorator('remove_photo', {
            initialValue: false
          })(
            <Input type="boolean" />
          )}
        </FormItem>
      </div>
    )
  }

  renderNameField() {
    const {getFieldDecorator} = this.props.form;

    return (
      <div>
        <FormItem label="NAME">
          {getFieldDecorator('name', {
            rules: [
              { required: true, message: 'Please enter your name' },
              { max: 70, message: 'size cannot be greater than 70' }
            ],

            initialValue: this.props.data.current_user.name,
          })(
            <Input prefix={<Icon type="user" className="profile-form__label-icon"/>} placeholder="Name"/>
          )}
        </FormItem>
        <div className='bold'><Icon type="book"/> {ROLES[this.props.data.current_user.type]}</div>
      </div>
    )
  }

  renderDepartmentField() {
    const {getFieldDecorator} = this.props.form;

    return (
      <FormItem label="DEPARTMENT">
        {getFieldDecorator('department', {
          initialValue: this.props.data.current_user.department,
        })(
          <Input prefix={<Icon type="solution" className="profile-form__label-icon"/>} placeholder="Department"/>
        )}
      </FormItem>
    )
  }

  renderPhoneField() {
    const {getFieldDecorator} = this.props.form;

    return (
      <FormItem label="PHONE #">
        {getFieldDecorator('phone', {
          initialValue: this.props.data.current_user.phone,
        })(
          <Input prefix={<Icon type="phone" className="profile-form__label-icon"/>} placeholder="Phone"/>
        )}
      </FormItem>
    )
  }

  render() {
    const fields = FIELDS[this.props.data.current_user.type];

    return (
      <Form onSubmit={this.onSubmit}>
        <Layout className="profile-page__content">
          <Row>
            <Col lg={7} xl={5} xxl={3} xs={24} className="profile-page__sider">
              { fields.includes('photo_data_uri') && this.renderPhotoDataUriField() }
            </Col>
            <Col xs={{span: 24}} lg={{offset: 1, span: 10}} className="profile-form__fields-area">
              <FormItem label="EMAIL (APP USERNAME)">
                <div>
                  <Icon type="mail" className="profile-form__label-icon"/>
                  <span className="profile-form__label bold">{this.props.data.current_user.email}</span>
                </div>
              </FormItem>
              { fields.includes('name') && this.renderNameField() }
              { fields.includes('department') && this.renderDepartmentField() }
              { fields.includes('phone') && this.renderPhoneField() }
              <div className="align-right profile-form__form-control">
                <Button onClick={() => this.props.onCancel()} className="profile-form__inactive-button">
                  CANCEL
                </Button>
                <Button type="primary" htmlType="submit" className="profile-form__submit-button" loading={this.state.loading}>
                  SAVE
                </Button>
              </div>
            </Col>
          </Row>
        </Layout>
      </Form>
    );
  }
}

export default Form.create()(compose(
  graphql(getCurrentUser),
  graphql(updateUser)
)(ProfileForm));




// WEBPACK FOOTER //
// ./src/components/pages/profile/form.js